<template>
  <div
    class="go-back"
    @click="goBack"
    :style="`color:${type === 1 ? '#fff' : '#232323'}`"
  >
    <svg-icon class="arrow" icon-class="arrow-right"></svg-icon>
    {{ name }}
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.push(this.path);
    },
  },
};
</script>
<style lang="scss" scoped>
.go-back {
  // background-color: #000;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  font-size: 16px;
  font-weight: bolder;
  z-index: 2;
  padding: 10px 0;
  .arrow {
    position: absolute;
    left: 18px;
    width: 24px;
    height: 24px;
    transform: rotate(180deg);
  }
}
</style>